import clients from './clientsReducer'
import locationsData from './locationsReducer'
import measurements from './measurementsReducer'
import auth from './authReducer'
import ui from './uiReducer'

export default {
    auth,
    ui,
    clients,
    locationsData,
    measurements
}


// WEBPACK FOOTER //
// ./src/reducers/reducers.js